import type { Locale } from '@change-corgi/config/locales';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { HomepagePageUserData as PageUserDataReturn } from '../types';

import type { HomepagePageUserDataQuery, HomepagePageUserDataQueryVariables } from './api.graphql';
import { HomepagePageUserData } from './api.graphql';

export async function getHomepagePageUserData(
	utilityContext: UtilityContext,
	{ locale }: { locale: string },
): Promise<PageUserDataReturn> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<HomepagePageUserDataQuery, HomepagePageUserDataQueryVariables>({
		query: HomepagePageUserData,
		rejectOnError: true,
	});

	const v3Config = data.featureConfigs.homepageV3.perLocaleConfig?.[locale as Locale];
	const showV3 = v3Config?.enabled ?? false;
	const sunriseExperimentEnabled = data.experiments.sunriseFoundationsExperienceStarters.variation === 'enabled';
	// Only show sunrise to users that have V3 enabled and if experiment is enabled
	const showSunrise = showV3 && sunriseExperimentEnabled;

	return {
		showV3,
		showSunrise,
		showHowToV3: (showV3 && v3Config?.layout.howTo) ?? false,
	};
}
